import Glide from '@glidejs/glide'
import { onMounted } from 'vue'

export default {
    name: 'CaseModule',
    props: {
        glideId: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        onMounted(() => {
            let glide = new Glide(
                props.glideId ? `#${props.glideId}` : '.glide',
                {
                    perView: 1,
                    gap: 0,
                    peek: {
                        after: 0,
                        before: 0
                    }
                }
            )
            glide.mount()

            // We need to call update to ensure glide is rendered
            // correctly without any peek
            glide.update()
        })
    }
}
